<template>
  <div :class="$style.condition">
    <header>
      <i :class="`iconfont yw-xiangzuo ${$style.back}`" @click="back"></i>
      <p>领取条件</p>
    </header>
    <!-- <p :class="$style.actHint">该活动仅对<span>本包新注册的玩家</span>开放</p> -->
    <div :class="$style.conditionList">
      <div v-for="(item, index) in conditionList" :key="index" :class="$style.conditionItem">
        <div>
          <div :class="$style.dateline" v-if="item.type != 'pay'"><span :class="$style.point"></span>{{item.dateline}}</div>
          <p :class="$style.level" v-if="item.type != 'pay' && !(index === 0 && receive_info.version == 1)">游戏角色<span>{{item.condition}}</span></p>
          <p :class="$style.dateline" v-if="item.type == 'pay'"><span :class="$style.point"></span>{{item.moneyText}}</p>
        </div>
        <div :class="$style.award">
          <p>{{item.award}}</p>
        </div> 
      </div>
      <!-- <p :class="$style.probability" @click="showProbability()" v-if="receive_info.rule_type === 2">查看礼包抽奖概率</p> -->
      <p :class="$style.hint">活动最终解释权归活动方所有</p>
    </div>
    <Probability v-if="probabilityVisible" @close="probabilityVisible=false"></Probability>
  </div>
</template>

<script> 
import { mapState } from 'vuex';
import Probability from './Probability';

export default {
  name: '',
  data() {
    return {
      probabilityVisible: false
    };
  },
  mounted() {
  },
  computed: {
    ...mapState({
      conditionList: state => state.redEnvelope.conditionList,
      receive_info: state => state.redEnvelope.receive_info,
    })
  },
  components: {
    Probability
  },
  methods: {
    back() {
      this.$emit('setPage', 'receive');
    },
    showProbability() {
      this.probabilityVisible = true;
    }
  }
}
</script>

<style lang="scss" module>
$font-lg: 15px;
$font-nm: 12px;
$font-sm: 9px;

.condition {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background: #ffffff;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  > header {
    padding: 12px 0 24px;
    position: relative;
    font-size: $font-lg;
    color: #424242;
    text-align: center;
    margin-bottom: 10px;
    background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/red-envelope/v2/condition_back.png');
    background-size: 100% 100%;
    color: #FFFFFF;
    > .back {
      position: absolute;
      left: 22px;
      font-size: $font-lg;
      box-sizing: content-box;
      padding: 5px { top: 0px; left: 0 };
    }
  }
  .actHint {
    font-size: $font-nm;
    text-align: left;
    margin-bottom: 10px;
    margin-left: 20px;
    > span {
      color: #FF5B58;
    }
  }
  .conditionList {
    padding: 0 21px;
    font-size: 0;
    .conditionItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      .dateline {
        color: #121212;
        font-size: 13px;
        font-weight:400;
        margin-bottom: 8px;
        .point {
          width: 4px;
          height: 4px;
          background: #E85333;
          border-radius: 50%;
          display: inline-block;
          vertical-align: middle;
          margin-right: 4px;
        }
      }
      .level {
        color: #707070;
        font-size: $font-sm;
        margin-left: 8px;
        max-width: 200px;
        > span {
          color: #FF5B58;
        }
      }
      .award {
        color: #FF5B58;
        font-size: 13px;
      }
    }
    .probability {
      font-size: $font-sm;
      text-align: right;
      color: #707070;
      margin-bottom: 10px;
    }
    .hint {
      font-size: $font-sm;
      text-align: center;
      color: #707070;
      margin-bottom: 10px;
    }
  }
}
</style>